/**
 * Batch H2 — Holder notification preferences (shared by onboarding + Settings).
 * Preferences are what the Holder wants; delivery shows which channels actually work today.
 */
import React from 'react';
import { Bell } from 'lucide-react';
import theme from '../../theme';

export const HOLDER_NOTIF_DEFAULTS = { claim_updates: true, benefit_unlocks: true, nft_issuance: true, account_security: true };
const ITEMS = [
  { key: 'claim_updates', label: 'Claim updates', hint: 'When a claim is recorded or a claim link you used changes.' },
  { key: 'benefit_unlocks', label: 'Benefit updates', hint: 'When a benefit becomes available, is scheduled, or is redeemed.' },
  { key: 'nft_issuance', label: 'NFT issuance', hint: 'When an NFT for one of your claims is issued on-chain.' },
  { key: 'account_security', label: 'Account & security', hint: 'Password resets and sign-in notices. Always on.', locked: true },
];

export default function HolderNotificationPrefs({ value, onChange, delivery }) {
  const v = { ...HOLDER_NOTIF_DEFAULTS, ...(value || {}) };
  const d = delivery || {};
  return (
    <div data-testid="holder-notification-prefs">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <Bell size={20} color={theme.colors.primary} />
        <h3 style={{ fontSize: 18, fontWeight: 600, color: theme.colors.text.primary }}>Notifications</h3>
      </div>
      <div style={{ display: 'grid', gap: 10 }}>
        {ITEMS.map(it => (
          <label key={it.key} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', cursor: it.locked ? 'default' : 'pointer' }}>
            <input data-testid={`holder-notif-${it.key}`} type="checkbox" checked={!!v[it.key]} disabled={it.locked}
              onChange={e => onChange({ ...v, [it.key]: e.target.checked })} style={{ marginTop: 3, width: 16, height: 16 }} />
            <span style={{ fontSize: 14 }}><b>{it.label}</b><br /><span style={{ fontSize: 12, color: theme.colors.text.muted }}>{it.hint}</span></span>
          </label>
        ))}
      </div>
      <div data-testid="holder-notif-delivery" style={{ marginTop: 12, fontSize: 12, color: theme.colors.text.muted }}>
        Delivered by: email {d.email ? <b style={{ color: '#065F46' }}>(active)</b> : <b style={{ color: '#92400E' }}>(not configured yet — preferences are saved for later)</b>}.
        Text and push notifications aren't available yet.
      </div>
    </div>
  );
}
